<template>
	<detail :is-view="true" />
</template>

<script>
	import Detail from './component/Detail'
	
	export default{
		name: 'ViewTask',
		components: {Detail}
	}
</script>